import { apiService } from '@/shared/services/api';
import { env } from '@/shared/config/env';
import { endpoints } from '@/shared/services/endpoints';
import type { Permission } from '@/shared/types/permissions';
import type { SessionOrganization, User } from '@/shared/types/entities';

export interface SessionResponse {
  token: string;
  user: User | null;
  organizations: SessionOrganization[];
  selectedOrganizationId: string | null;
  permissions: Permission[];
}

export async function loginSession(email?: string): Promise<SessionResponse> {
  const { data } = await apiService.post<{ data: SessionResponse }>(endpoints.auth.login(), {
    email,
  });
  return data.data;
}

export async function fetchSession(): Promise<SessionResponse> {
  const { data } = await apiService.get<{ data: SessionResponse }>(endpoints.auth.session());
  return data.data;
}

export async function selectOrganization(organizationId: string): Promise<SessionResponse> {
  const { data } = await apiService.post<{ data: SessionResponse }>(
    endpoints.auth.selectOrganization(),
    { organizationId },
  );
  return data.data;
}

export async function createOrganization(name: string): Promise<SessionResponse> {
  const { data } = await apiService.post<{ data: SessionResponse }>(
    endpoints.auth.createOrganization(),
    { name },
  );
  return data.data;
}

export function getEventsSSOUrl(): string {
  return `${env.VITE_API_BASE_URL}${endpoints.auth.ssoEventsConnect()}`;
}

export type OrgSyncStatusResponse =
  | { status: 'syncing' }
  | { status: 'complete'; session: SessionResponse };

export async function fetchOrgSyncStatus(): Promise<OrgSyncStatusResponse> {
  const { data } = await apiService.get<{ data: OrgSyncStatusResponse }>(
    endpoints.auth.orgSyncStatus(),
  );
  return data.data;
}
